export class PurchaseRequest {
  public Configuration = new class {
    public Agent = "RADON.WEB";
    public ClientCode!: string;
    public Channel = "Web";
    public ISOCurrency = "CAD";
  }
  // public Payments!: {};

  public CurrentCoverage = new class {
    public PurchaseDate!: string;
    public PricingDate!: string;
    public StartDate!: string;
    public EndDate!: string;
    public ProvinceOfResidence!: string;
    public Insured!: {};
  }

  // public Consents!: {}

  public FulfillmentPreference!: string;

  // public Addresses!: {}
  
  constructor() {}

  public getPolicy(callback: any) {
    const xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState === 4) {
        if(this.status===200){
          callback(this.status, JSON.parse(this.responseText));
        }
        else {
          callback(this.status);
        }
      }
    };
    xhttp.open("POST", "/api/purchase", true);
    xhttp.setRequestHeader("Content-type", "application/json");

    xhttp.send(JSON.stringify(this));
    // alert (JSON.stringify(this));
  }
}